<template>
  <transition name="fade">
    <div class="box">
      <span>Nova versão disponível!</span>
      <button
        type="button"
        class="update-button fs-18 no-outline"
        @click="refreshApp()"
      >
        Atualizar
      </button>
      <span @click="$emit('closed')" class="c-pointer">
        <i class="fas fa-times fs-14"></i>
      </span>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      refreshing: false,
    };
  },
  props: {
    registration: {
      required: true,
    },
  },
  created() {
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (this.refreshing) return;
        this.refreshing = true;
        window.location.reload(true);
      });
    }
  },
  methods: {
    refreshApp() {
      if (!this.registration || !this.registration.waiting) {
        return;
      }
      this.registration.waiting.postMessage('skipWaiting');

      this.$emit('updated');
    },
  },
};
</script>

<style scoped>
.box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  padding: 16px 24px;
  border-radius: 8px;
  width: 25%;
  bottom: 2%;
  right: 2%;
  background: rgb(0, 0, 0);
  color: var(--white);
  box-shadow: 0 0 15px var(--alpha-black);
}

.update-button {
  background: var(--orange-gradient);
  width: 88px;
  height: 36px;
  border-radius: 4px;
  border: none;
  color: var(--white);
}

@media screen and (max-width: 1100px) {
  .box {
    width: 40%;
  }
}
@media screen and (max-width: 700px) {
  .box {
    width: 55%;
  }
}

@media screen and (max-width: 550px) {
  .box {
    width: 90%;
    bottom: 2%;
    right: 5%;
  }
}
</style>
